<div class="duration d-flex align-items-center">
  <mat-icon [class]="iconClass" svgIcon="clock_v2"></mat-icon>
  <span>{{getDuration()}}</span>
</div>
